<!--
================================================
View pour la gestion de l'abonnement
http://localhost:8080/fr/hotjar-inc/subscription
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template >
    <app-layout-comp>
        <div slot="AppContent" id="WorkspaceSubscriptionView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

          <div class="compLoader" v-if="!componentIsReady">
            <spinner-loader-comp v-bind:loading-txt="$t('chargement')"></spinner-loader-comp>
          </div>
          <div v-else>

            <div class="box px-0 py-0 mb-6 notVerifiedWarn" v-if="!user.isVerified && user != undefined">
              <article class="message is-warning has-text-left">
                <div class="message-body">
                  <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon mr-1" />

                  <span v-html="$t('vousDevezValiderVotreCompteAvantDeModifierVotreAbonnement',{'email':user.email})"></span>
                  <span class="help">
                  <span class="mr-1">{{$t('vousNAvezPasRecuLeLien')}}</span>
                  > <a v-bind:href="supportEmail+'?subject=Activation link resend request &body='+user.email" target="_blank">{{ $t('contactezNotreSupport')}}</a>
                </span>


                </div>
              </article>
            </div>

            <div class="columns">
                <div class="column">

                    <!-- titre de la page ----------------------------------------------->
                    <div class="has-text-left appTitle">
                        <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'medal']" />{{$t('Abonnement')}}</h3>
                        <p class="appSubTitle">{{$t('IciVousPouvezGérerVotreAbonnement')}}</p>
                    </div>

                  <workspace-setting-subscription-comp
                      v-if="activeProductComput.name!= null"
                      v-bind:plan-name="activeProductComput.name"
                      v-bind:quantity="activeSubscriptionComput.quantity"
                      v-bind:active-stripe-subscription="activeSubscriptionComput" v-bind:active-stripe-product="activeProductComput"></workspace-setting-subscription-comp>

                  <plans-blocs-section-comp v-if="stripeCustomerEmailComput" :stripe-checkout-session="stripeCheckoutSession" :stripe-customer-email="stripeCustomerEmail" :active-stripe-price-id="activeSubscriptionComput.plan.id"
                  ></plans-blocs-section-comp>

                  <faq-section v-if="plansSpecLoaded"></faq-section>



                </div>
            </div>

          </div>
        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    // import Component from '@/components/Component.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    import {mapState} from "vuex";
    import { StripeCheckout } from '@vue-stripe/vue-stripe';
    import WorkspaceSettingSubscriptionComp from "@/components/subscription/WorkspaceSettingSubscriptionComp";
    import FaqSection from "@/components/pricing/faqSection";
    import PlansBlocsSectionComp from "@/components/pricing/plansBlocsSectionComp";
    import ModalPremiumLimitationComp from "@/components/ModalPremiumLimitationComp";

    export default {
        name: 'WorkspaceSubscriptionView',
      components: {
        ModalPremiumLimitationComp,
        PlansBlocsSectionComp,
        FaqSection,
        WorkspaceSettingSubscriptionComp,
        AppLayoutComp,SpinnerLoaderComp, StripeCheckout
        // Component,
      },
      data: function () {
          return {
            locale: this.$route.params.locale,
            organizationSlug: this.$route.params.organization,
            userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
            supportEmail: 'mailto:'+ process.env.VUE_APP_SUPPORT_EMAIL, // lien mailto vers le support
            stripeCheckoutSession: {}, // L'objet Stripe checkout session (sert de variable à stripeCheckoutSessionComput)

            workspaceActiveUserCount: 0 , // Le nombre total de user actifs dans le workspace

            loading: false,
            lineItems: [
              {
                price: 'price_1JfRDtCOTk6iEkMocnqnW59m', // The id of the recurring price you created in your Stripe dashboard
                quantity: 1,
              }

            ],

            activeWorkspace: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290
            stripeCustomerEmail: null, //Email du client stripe | sert de variable à stripeCustomerEmailComput
            activeStripeSubscription: {}, // Un object stripe subscription | la souscription actuelle active dans le workspace en cours | sert de variable à activeStripeSubscriptionComput
            activeStripeProduct: {}, // Un object stripe product | Le plan active dans le workspace en cours | sert de variable à activeStripeProductComput

            componentIsReady: false, // indique quand le composant est prêt à être afficher
            plansSpecLoaded: false,// Bool indiquant si les tarifs on été chargés dans plansBlocSectionComp
                // =================================================================
            }
        },
        computed:{
            // computed props for store :
            ...mapState({
              user: state => state.user,
              currentPeriod: state => state.ReportView.currentPeriod,
                themeToDisplay: state => state.app.themeToDisplay,
                workspaceTrialStarted : state => state.SubscriptionView.workspace.trialStarted
            }),

            //----------------------------------------------
            // other computed props :

          /**
           * L'email de l'utilisateur actuel
           */
          stripeCustomerEmailComput: {
            get: function(){
              return this.stripeCustomerEmail
            },
            set: function (value){
              this.stripeCustomerEmail= value
            }
          },
            /**
             * La subscription en cours du workspace (Un objet stripe subscription)
             */
            activeSubscriptionComput: {
              get: function(){
                  return this.activeStripeSubscription
                },
              set: function (value){
                this.activeStripeSubscription= value
              }
            },

          /**
           * La subscription en cours du workspace (Un objet stripe subscription)
           */
          activeProductComput: {
            get: function(){
              return this.activeStripeProduct
            },
            set: function (value){
              this.activeStripeProduct= value
            }
          }
            //----------------------------------------------


        },
        // watch: {
        // },
        mixins: [VueMetaMixin, SentryMixin, InterceptorMixin, GlobalErrorNotificationMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleSubscription"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {

          /**
           * Soumission de vue-stripe
           */
          submit () {
            // You will be redirected to Stripe's secure checkout page
            this.$refs.checkoutRef.redirectToCheckout();
          },

          /*
          Effectue une requête pour récupérer :
           - la stripe subscription en cours dans le workspace
           - le produtct lié à la subscription stripe
           - l'email de l'utilisateur atuel
           - le nombre total d'utilisateurs actif dans le workspace (récupéré en même temps par souci d'optimisation)
          */
          getWorkspaceSubscription() {
            let self =this;
            return self.$http
                .get(`/s/organizations/${self.organizationSlug}/workspaces/${self.activeWorkspace}/subscription/current`
                    ,{headers: {Authorization: self.$auth.header()},
                      timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps pour les tests en dev

                    })
                .then(function (response) {
                  self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                  self.$store.commit('UpdateSubscriptionViewWorkspaceTrialEnd', response.data.subscription.trial_end)

                  self.activeSubscriptionComput= response.data.subscription
                  self.stripeCustomerEmailComput= response.data.customerEmail
                  self.activeProductComput= response.data.product
                  self.workspaceActiveUserCount= response.data.workspaceActiveUserCount
                  self.componentIsReady = true;
                  return {
                  }
                })
                .catch(function (error) {
                  let errorCode = '0055' //
                  let errorMsg = 'error on fetching stripe subscription'
                  self.showGlobalErrorNotif(self,errorCode)
                  self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsg, 'fatal': false})

                  self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsg})
                  self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsg} : ${error}`, 'error')

                }).then(() => {
                  // toujours exécuté
                  self.componentIsReady = true;
                })
          },


          /**
           * Récupère le workspace actuel
           */
          loadActiveWorkspace() {
            let self = this;
            self.$http.get(
                `organizations/${self.$auth.getOrganization()}/workspaces/${self.activeWorkspace}`,
                {
                  params: {},
                  headers: {Authorization: self.$auth.header()}
                }
            )
                .then(function (response) {
                  self.$store.commit('UpdateSubscriptionViewWorkspaceTrialStarted', response.data.trialStarted) //#todo utile de stocker dans le store ? besoin ailleurs ?

                })
                .catch(function (error) {
                  // On catch ici sauf ce qui relève des intercepteurs Axios
                  if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                    self.logToSentry(self, error, 'error')
                    let errorCode = '0052b' //@todo maj code
                    let errorDetail = "error fetching workspace currency"
                    self.showGlobalErrorNotif(self, errorCode)
                    self.$gtag.exception({'description': 'error ' + errorCode + ' | error ' + errorDetail, 'fatal': false})
                    self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": error})
                    self.$sentry.captureMessage(`Error ${errorCode} > ${errorDetail} : ${error}`, 'error')
                  }
                })
                .then(() => {
                  // toujours exécuté
                })
          },

        },

        created: function () {
        },
        mounted: function () {
          this.loadActiveWorkspace();
          this.getWorkspaceSubscription()

          // listener du chargement des tarifs plans_spec_loaded
          this.$root.$once('plans_spec_loaded', () => {
            this.plansSpecLoaded = true
          })

        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/
pre {background-color: #333; color: #ccc}//@todo temporaire structurezVotreSuiviDeTempsPourConnaitreLeTempsPasséSurChaqueProjetEtClient
</style>

<style scoped lang="scss">
    @import "../assets/css/bulmaCustom.scss";
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #WorkspaceSubscriptionView{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        .notVerifiedWarn .message{
          background-color: $darkYellow !important;
         .message-body{
            color: $white !important;
           .help{color:lighten($darkLightBlue,20%);}
         }
        }
      }

    }
</style>
